"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfig = void 0;
var tslib_1 = require("tslib");
var _config = {
    onUnhandledError: function (err) {
        console.error(err);
        /*do nothing */
    },
    pagination: { pageStart: 1, perPage: 25 }
};
function setHoustonHooksConfig(config) {
    var _a;
    _config = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, _config), config), { pagination: tslib_1.__assign(tslib_1.__assign({ pageStart: 1, perPage: 25 }, _config.pagination), ((_a = config.pagination) !== null && _a !== void 0 ? _a : {})) });
    configRxjs();
}
exports.default = setHoustonHooksConfig;
function configRxjs() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var rxjs;
        return tslib_1.__generator(this, function (_a) {
            try {
                rxjs = require('rxjs');
                if (rxjs.config && !rxjs.config.onUnhandledError) {
                    rxjs.config.onUnhandledError = function (err) { return _config.onUnhandledError(err, 'rxjs'); };
                }
            }
            catch (err) {
                /* Sem problemas, o projeto não tem rxjs */
            }
            return [2 /*return*/];
        });
    });
}
function getConfig() {
    return _config;
}
exports.getConfig = getConfig;
